import { Component, inject, Inject, EventEmitter, Output } from '@angular/core';
import { Account } from '../../../../../service/account.service';
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import { MatCardModule } from '@angular/material/card';
import { EditUserVrchatComponent } from './edit-user-vrchat/edit-user-vrchat.component';
import { EditUserPatreonComponent } from './edit-user-patreon/edit-user-patreon.component';
import { AvatarComponent } from '../../../../../helper/avatar/avatar.component';

@Component({
  selector: 'app-edit-user',
  imports: [MatDialogModule, MatButtonModule, MatListModule, MatCardModule, AvatarComponent],
  templateUrl: './edit-user.component.html',
  styleUrl: './edit-user.component.less'
})
export class EditUserComponent {

  dialog = inject(MatDialog);
  
  @Output() userUpdated = new EventEmitter<Account>();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { user: Account }
  ) {
    console.log(this.data);
  }

  openVRChatAccount() {
    const vrchatDialog = this.dialog.open(EditUserVrchatComponent, {
      data: {
        user: this.data.user
      }
    });

    // Listen for user updates from the VRChat dialog
    vrchatDialog.componentInstance.userUpdated.subscribe((updatedUser: Account) => {
      // Update the local user data
      this.data.user = updatedUser;
      // Emit the updated user to the parent component
      this.userUpdated.emit(updatedUser);
    });
  }

  openPatreonAccount() {
    const patreonDialog = this.dialog.open(EditUserPatreonComponent, {
      data: {
        user: this.data.user
      }
    });

    // Listen for user updates from the Patreon dialog
    patreonDialog.componentInstance.userUpdated.subscribe((updatedUser: Account) => {
      // Update the local user data
      this.data.user = updatedUser;
      // Emit the updated user to the parent component
      this.userUpdated.emit(updatedUser);
    });
  }
}
